/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PlatformStorageUsageSummaryResponse,
  TenantPlatformStoragePolicyResponse,
  UpsertTenantPlatformStoragePolicyRequest,
} from '../models/index';
import {
    PlatformStorageUsageSummaryResponseFromJSON,
    PlatformStorageUsageSummaryResponseToJSON,
    TenantPlatformStoragePolicyResponseFromJSON,
    TenantPlatformStoragePolicyResponseToJSON,
    UpsertTenantPlatformStoragePolicyRequestFromJSON,
    UpsertTenantPlatformStoragePolicyRequestToJSON,
} from '../models/index';

export interface ClearPolicyRequest {
    tenantId: string;
    sessionId?: string;
}

export interface GetPolicyRequest {
    tenantId: string;
    sessionId?: string;
}

export interface GetUsage1Request {
    tenantId: string;
    sessionId?: string;
    periodStart?: Date;
    periodEnd?: Date;
}

export interface UpsertPolicyRequest {
    tenantId: string;
    upsertTenantPlatformStoragePolicyRequest: UpsertTenantPlatformStoragePolicyRequest;
    sessionId?: string;
}

/**
 * TenantPlatformStorageApi - interface
 * 
 * @export
 * @interface TenantPlatformStorageApiInterface
 */
export interface TenantPlatformStorageApiInterface {
    /**
     * 
     * @summary Opt out of platform-managed extended retention (revert to COGS default cap)
     * @param {string} tenantId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantPlatformStorageApiInterface
     */
    clearPolicyRaw(requestParameters: ClearPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Opt out of platform-managed extended retention (revert to COGS default cap)
     */
    clearPolicy(requestParameters: ClearPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Get tenant platform-managed storage policy (opt-in and retention)
     * @param {string} tenantId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantPlatformStorageApiInterface
     */
    getPolicyRaw(requestParameters: GetPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantPlatformStoragePolicyResponse>>;

    /**
     * Get tenant platform-managed storage policy (opt-in and retention)
     */
    getPolicy(requestParameters: GetPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantPlatformStoragePolicyResponse>;

    /**
     * 
     * @summary Platform-managed storage usage and estimated pass-through cost for a period
     * @param {string} tenantId 
     * @param {string} [sessionId] 
     * @param {Date} [periodStart] 
     * @param {Date} [periodEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantPlatformStorageApiInterface
     */
    getUsage1Raw(requestParameters: GetUsage1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlatformStorageUsageSummaryResponse>>;

    /**
     * Platform-managed storage usage and estimated pass-through cost for a period
     */
    getUsage1(requestParameters: GetUsage1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlatformStorageUsageSummaryResponse>;

    /**
     * 
     * @summary Opt in or update platform-managed storage retention (requires billing attestation)
     * @param {string} tenantId 
     * @param {UpsertTenantPlatformStoragePolicyRequest} upsertTenantPlatformStoragePolicyRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantPlatformStorageApiInterface
     */
    upsertPolicyRaw(requestParameters: UpsertPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantPlatformStoragePolicyResponse>>;

    /**
     * Opt in or update platform-managed storage retention (requires billing attestation)
     */
    upsertPolicy(requestParameters: UpsertPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantPlatformStoragePolicyResponse>;

}

/**
 * 
 */
export class TenantPlatformStorageApi extends runtime.BaseAPI implements TenantPlatformStorageApiInterface {

    /**
     * Opt out of platform-managed extended retention (revert to COGS default cap)
     */
    async clearPolicyRaw(requestParameters: ClearPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling clearPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{tenantId}/storage/platform/policy`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Opt out of platform-managed extended retention (revert to COGS default cap)
     */
    async clearPolicy(requestParameters: ClearPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.clearPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tenant platform-managed storage policy (opt-in and retention)
     */
    async getPolicyRaw(requestParameters: GetPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantPlatformStoragePolicyResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{tenantId}/storage/platform/policy`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantPlatformStoragePolicyResponseFromJSON(jsonValue));
    }

    /**
     * Get tenant platform-managed storage policy (opt-in and retention)
     */
    async getPolicy(requestParameters: GetPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantPlatformStoragePolicyResponse> {
        const response = await this.getPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Platform-managed storage usage and estimated pass-through cost for a period
     */
    async getUsage1Raw(requestParameters: GetUsage1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlatformStorageUsageSummaryResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getUsage1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['periodStart'] != null) {
            queryParameters['periodStart'] = (requestParameters['periodStart'] as any).toISOString();
        }

        if (requestParameters['periodEnd'] != null) {
            queryParameters['periodEnd'] = (requestParameters['periodEnd'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{tenantId}/storage/platform/usage`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlatformStorageUsageSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Platform-managed storage usage and estimated pass-through cost for a period
     */
    async getUsage1(requestParameters: GetUsage1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlatformStorageUsageSummaryResponse> {
        const response = await this.getUsage1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Opt in or update platform-managed storage retention (requires billing attestation)
     */
    async upsertPolicyRaw(requestParameters: UpsertPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantPlatformStoragePolicyResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling upsertPolicy().'
            );
        }

        if (requestParameters['upsertTenantPlatformStoragePolicyRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertTenantPlatformStoragePolicyRequest',
                'Required parameter "upsertTenantPlatformStoragePolicyRequest" was null or undefined when calling upsertPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{tenantId}/storage/platform/policy`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertTenantPlatformStoragePolicyRequestToJSON(requestParameters['upsertTenantPlatformStoragePolicyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantPlatformStoragePolicyResponseFromJSON(jsonValue));
    }

    /**
     * Opt in or update platform-managed storage retention (requires billing attestation)
     */
    async upsertPolicy(requestParameters: UpsertPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantPlatformStoragePolicyResponse> {
        const response = await this.upsertPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
